import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react';
import {API_URL} from '../index';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Organisation from './Organisation'
import NewOrg from './NewOrg';
import Tooltip from '@material-ui/core/Tooltip';
import Select from 'react-select';
import {Grid, Divider} from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Slider from '@material-ui/core/Slider';



const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },
}));


const OrganisationList = forwardRef((props, ref) => {

  const classes = useStyles();

  const [organisations, setOrganisations] = useState();
  const [fetching, setFetching] = useState();
  const [page, setPage] = useState(props.page);
  const [response, setResponse] = useState();
  const [checked, setChecked] = useState(false);
  const [checked_spec, setCheckedSpec] = useState(false);
  const [archive, setArchive] = useState();
  const [archives, setArchives] = useState();
  const [checked_archives_spec, setCheckedArchivesSpec] = useState();
  const [current_page, setCurrentPage] = useState();
  const [base_page, setBasePage] = useState();


  useEffect(() => {
      loadOrganisationList();
  }, []);


  const loadOrganisationList = (page, filter, page_number) => {
      const token = localStorage.getItem('token') != null ? 'Token ' + localStorage.getItem('token') : ''
      setCurrentPage(page_number !== undefined ? page_number : 1)
      setFetching(true)
      const organisation_url = page ? page : filter != undefined ? (API_URL + filter + '&page=' + page_number) : API_URL + 'organisations/?page=' + (page_number ? page_number : 1)
        fetch(organisation_url, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'Authorization': token }
        })
        .then(response => {setPage(response.url); setResponse(response); return response.json()})
        .then(data => setOrganisations(data))
        .then(e => setFetching(false))
  }


  useImperativeHandle(ref, () => ({
    update() {
        loadOrganisationList();
    }
  }));

  const filterOn = () => {
      setChecked(!checked);
      loadOrganisationList(null, 'organisations_by_archive/?id=' + props.archive.id, 1);
      setBasePage('organisations_by_archive/?id=' + props.archive.id);
  };

  const filterSpecOn = () => {
      setCheckedSpec(!checked_spec);
      loadOrganisationList(null, 'organisations_spec_by_archive/?id=' + props.archive.id, 1);
      setBasePage('organisations_spec_by_archive/?id=' + props.archive.id);
  };

  const nonFilter = () => {
      setChecked(!checked);
      loadOrganisationList();
  };

  const nonSpecFilter = () => {
      setCheckedSpec(!checked_spec);
      loadOrganisationList();
  };

  const loadArchives = () => {
      const archives_url = API_URL + 'archives/'

      fetch(archives_url, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        })
        .then(response => response.json())
        .then(data => data.results.map(archive => ({
                        value: archive.id,
                        label: archive.title_short,
                      })))
        .then(data => setArchives(data))
  };

  const ArchivesSpec = () => {
      setCheckedArchivesSpec(!checked_archives_spec);
      loadArchives();
  };

  const nonArchivesSpec = () => {
      setCheckedArchivesSpec(!checked_archives_spec);
      loadOrganisationList();
      setArchive(undefined);
      setArchives(undefined);
  };

  const handleChangeArchiveLS = archive => {
      setArchive(archive);
      loadOrganisationList(null, 'organisations_spec_by_archive/?id=' + archive.value, 1);
      setBasePage('organisations_spec_by_archive/?id=' + archive.value);
  };

  return (
    <React.Fragment>
    { organisations != undefined ?
    <Paper className={classes.root} >
      <Table className={classes.table} size='small'>
        <TableHead>
          <TableRow style={{backgroundColor: '#4c5866'}}>
            <TableCell align="left" style={{color: '#f0f8ff'}}>ID</TableCell>
            <TableCell align="left" style={{color: '#f0f8ff'}}>Наименование организации</TableCell>
            <TableCell align="right" style={{color: '#f0f8ff'}}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {organisations.results.map(organisation => (
            <TableRow key={organisation.id} hover style={{backgroundColor: organisation.is_open ? '' : '#ffcabd'}}>
              <TableCell align="left">{organisation.id}{organisation.archive_spec != null ?
                                                <Tooltip title={'На уточнении'} placement='right'><ErrorOutlineIcon fontSize='small' color='error'/></Tooltip> :
                                                <div></div>}
              </TableCell>
              <TableCell align="left" component="th" scope="row">
                {organisation.title} <u><i style={{color: '#4b0082'}}>{organisation.archive_fund != null ? organisation.archive_fund : ''}</i></u>
              </TableCell>
              <TableCell align="right">
              <Organisation organisation={organisation} user={props.user} archive={props.archive} refresh={e => loadOrganisationList(page)}/>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {props.user != undefined && props.archive != undefined ?
        <Tooltip title={'Показывать только записи ' + props.archive.title_short} placement='bottom'>
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={checked ? nonFilter : filterOn}
                value="checked"
                color="primary"
                disabled={checked_spec || checked_archives_spec ? true : false}
              />
            }
            label="Фильтр по архиву"
            style={{float: 'left', margin: '3px'}}
          />
        </Tooltip>
      :<br/>}
      {props.user != undefined && props.archive != undefined ?
        <Tooltip title={'На уточнении для ' + props.archive.title_short} placement='bottom'>
          <FormControlLabel
            control={
              <Checkbox
                checked={checked_spec}
                onChange={checked_spec ? nonSpecFilter : filterSpecOn}
                value="checked"
                color="secondary"
                disabled={checked || checked_archives_spec ? true : false}
              />
            }
            label="На уточнении"
            style={{float: 'left', margin: '3px'}}
          />
        </Tooltip>
      :<br/>}
      {props.user != undefined && props.archive != undefined && props.archive.id == 3 ?
        <Tooltip title={'На уточнении по всем архивам'} placement='bottom'>
          <FormControlLabel
            control={
              <Checkbox
                checked={checked_archives_spec}
                onChange={checked_archives_spec ? nonArchivesSpec : ArchivesSpec}
                value="checked"
                color="default"
                disabled={checked || checked_spec ? true : false}
              />
            }
            label="На уточнении (по всем архивам)"
            style={{float: 'left', margin: '3px'}}
          />
        </Tooltip>
      :<br/>}
      <br/>
      <Grid container>
        <Grid xs={1}>
        </Grid>
        <Grid xs={5}>
        {archives ?
          <Select
            native
            value={archive}
            onChange={handleChangeArchiveLS}
            options={archives}
            placeholder="Архив"
          />
        :
        <div><br/></div>}
        </Grid>
        <Grid xs={6}>
        </Grid>
      </Grid>
      <br/>
      <br/>
      <Grid container>
      <Grid item xs={1}>
      </Grid>
      <Grid item xs={10}>
            <Slider
              // defaultValue={1}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              value={current_page}
              onChangeCommitted={(event,value) => loadOrganisationList(null, base_page, value)}
              step={1}
              marks
              min={1}
              max={(organisations.count - organisations.count % 10) / 10 + 1}
            />
      </Grid>
      <Grid item xs={1}>
      </Grid>
      </Grid>
            <ButtonGroup size="small" aria-label="small outlined button group">
              {organisations.previous === null ?
              <Button disabled>Предыдущая</Button> :
              <Button onClick={e => (loadOrganisationList(organisations.previous), setCurrentPage(current_page - 1))}>Предыдущая</Button>}
              {organisations.next === null ?
              <Button disabled>Следующая</Button> :
              <Button onClick={e => (loadOrganisationList(organisations.next), setCurrentPage(current_page + 1))}>Следующая</Button>}
            </ButtonGroup>
            <h5>Страница {current_page} из { (organisations.count - organisations.count % 10) / 10 + 1 } </h5>
            <h5>Всего организаций: {organisations.count} </h5>
    </Paper>
    :
    <div></div>
    }
    </React.Fragment>
  );
})

export default OrganisationList;